"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_TYPE_SIZE = exports.FIELD_NAME_SIZE = exports.MAX_VISIBLE_FIELDS = exports.MAX_NODE_WIDTH = exports.FIELD_HEIGHT = void 0;
exports.FIELD_HEIGHT = 28;
exports.MAX_NODE_WIDTH = 350;
exports.MAX_VISIBLE_FIELDS = 10;
exports.FIELD_NAME_SIZE = 12;
exports.FIELD_TYPE_SIZE = 10;
